export const FLYERS_STATUS = {
  scheduled: { label: 'Agendada', template: 'warning' },
  pause: { label: 'Pausada', template: 'warning' },
  active: { label: 'Ativa', template: 'success' },
  finished: { label: 'Finalizada', template: 'info' },
  canceled: { label: 'Cancelada', template: 'danger' }
}
